import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-unsplash', 'BrandUnsplash', [["path",{"d":"M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z","key":"svg-0"}]]);